export const defaultSquareMeterPerPaintLiter = 5